import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import auth from '@/services/auth'

import PublicLayout from '@/views/Public/Layout'
import PublicRoutes from '@/routes/PublicRoutes'

import PrivateLayout from '@/views/Private/Layout'
import PrivateRoutes from '@/routes/PrivateRoutes'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: PrivateLayout,
      children: PrivateRoutes,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      component: PublicLayout,
      children: PublicRoutes
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if ((Object.keys(store.state.auth).length === 0 && store.state.auth.constructor === Object) || !store.state.auth.access_token) {
      if (to.fullPath !== '/') {
        next({ path: '/login', query: { redirect: to.fullPath } })
      } else {
        next({ path: '/login' })
      }
      return
    }

    if (!to.matched.some(record => record.meta.hasOwnProperty('role'))) {
      to.query.redirect ? next(to.query.redirect) : next()
      return
    }
    if (!to.matched.some(record => auth.hasRole(record.meta.role))) {
      next({ name: 'forbidden' })
      return
    }
  }
  next()
})

export default router
